export default function dummy() {
    return true;
}
// to prevent clipping:
// negative snr's decrease the digit/carrier db and keep noise at 0
// positive snr decrease noise and keep digit/carrier at 0
export function getDBOffsets(snr) {
    if (snr <= 0) {
        return { digitCarrier: snr, noise: 0 };
    }
    return { digitCarrier: 0, noise: -snr };
}
